import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/dfehyjw5juj.png";
import iso from "../../assets/iso.png";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaWhatsapp } from "react-icons/fa";
import { RiStockFill } from "react-icons/ri";
import { SiGoogleads } from "react-icons/si";
import { BsGlobe } from "react-icons/bs";

const Footer = () => {
  const courses = [
    { name: "Social Media Management", icon: <RiStockFill className="text-amber-500" /> },
    { name: "Digital Marketing", icon: <SiGoogleads className="text-blue-500" /> },
    { name: "Spoken English", icon: <BsGlobe className="text-green-500" /> }
  ];

  const links = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Courses", path: "/courses" },
    { name: "Contact", path: "/contact" }
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 text-white pt-16 pb-8 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-500 via-purple-500 to-orange-500"></div>
      <div className="absolute -bottom-20 -right-20 w-64 h-64 rounded-full bg-cyan-500/10 blur-3xl"></div>
      <div className="absolute -bottom-40 left-0 w-64 h-64 rounded-full bg-purple-500/10 blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <img src={logo} alt="Ambey Nexus" className="h-12" />
              {/* <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-500">
                Ambey Nexus
              </span> */}
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Empowering individuals and businesses through innovative education and digital solutions. Transforming aspirations into achievements.
            </p>
            <div className="flex items-center space-x-3 bg-gray-800/50 p-3 rounded-lg border border-gray-700 w-fit">
              <img src={iso} alt="ISO Certified" className="h-10" />
              <span className="text-sm text-gray-300">ISO 9001:2015 Certified</span>
            </div>
          </div>

          {/* Courses */}
          <div>
            <h4 className="text-xl font-bold mb-6 text-white flex items-center">
              <span className="w-4 h-4 rounded-full bg-gradient-to-r from-amber-500 to-orange-500 mr-3"></span>
              Our Services & Courses
            </h4>
            <ul className="space-y-4">
              {courses.map((course, index) => (
                <li key={index} className="flex items-center space-x-3 group">
                  <span className="text-lg">{course.icon}</span>
                  <Link
                    to="/courses"
                    className="text-gray-400 group-hover:text-white transition-colors duration-300"
                  >
                    {course.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-6 text-white flex items-center">
              <span className="w-4 h-4 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 mr-3"></span>
              Quick Links
            </h4>
            <ul className="space-y-4">
              {links.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-colors duration-300 flex items-center"
                  >
                    <span className="w-2 h-2 rounded-full bg-gray-600 mr-3"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-bold mb-6 text-white flex items-center">
              <span className="w-4 h-4 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 mr-3"></span>
              Connect With Us
            </h4>
            <div className="space-y-5">
              <div className="flex items-start space-x-3">
                <div className="mt-1">
                  <div className="w-6 h-6 rounded-full bg-gradient-to-r from-blue-500 to-cyan-500 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                </div>
                <div>
                  <p className="text-gray-400 text-sm">Phone</p>
                  <p className="text-white">+91 7889274462</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="mt-1">
                  <div className="w-6 h-6 rounded-full bg-gradient-to-r from-green-500 to-emerald-500 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                </div>
                <div>
                  <p className="text-gray-400 text-sm">Email</p>
                  <p className="text-white">info@ambeynexus.com</p>
                </div>
              </div>

              <div className="pt-2">
                <div className="flex space-x-4">
                  <a href="https://www.facebook.com/share/SUm6Vp1S7uW1suBc/?mibextid=qi2Omg" className="text-gray-400 hover:text-blue-500 transition-colors duration-300 transform hover:-translate-y-1">
                    <FaFacebook className="w-6 h-6" />
                  </a>
                  <a href="/#" className="text-gray-400 hover:text-blue-400 transition-colors duration-300 transform hover:-translate-y-1">
                    <FaTwitter className="w-6 h-6" />
                  </a>
                  <a href="https://www.instagram.com/ambeynexus?igsh=bjMxa2Vwend6d2l3" className="text-gray-400 hover:text-pink-600 transition-colors duration-300 transform hover:-translate-y-1">
                    <FaInstagram className="w-6 h-6" />
                  </a>
                  <a href="https://www.linkedin.com/company/ambey-nexus" className="text-gray-400 hover:text-blue-700 transition-colors duration-300 transform hover:-translate-y-1">
                    <FaLinkedin className="w-6 h-6" />
                  </a>
                  <a href="https://wa.me/917696637927" className="text-gray-400 hover:text-green-500 transition-colors duration-300 transform hover:-translate-y-1">
                    <FaWhatsapp className="w-6 h-6" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="border-t border-gray-800 pt-8 mt-8 relative">
          <div className="absolute -top-16 left-1/2 transform -translate-x-1/2 w-32 h-32 rounded-full bg-gradient-to-r from-cyan-500/20 to-blue-500/20 blur-3xl"></div>

          <div className="text-center relative">
            <div className="absolute -top-16 left-1/2 transform -translate-x-1/2">
              <div className="text-6xl md:text-8xl font-bold text-gray-800/20 tracking-wider select-none">
                AMBEY NEXUS
              </div>
            </div>

            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} Ambey Nexus. All rights reserved.
            </p>
            <div className="flex justify-center space-x-4 mt-4 text-gray-500 text-sm">
              <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
              <span>•</span>
              <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
              <span>•</span>
              <Link to="/disclaimer" className="hover:text-white transition-colors">Disclaimer</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;